///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2025
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";
import newBidValidationDefaults from "../helpers/newBidValidationDefaults";
import { getBidNameExists, getBidNameExistsForShipper } from "../api/bids";
import { cloneDeep } from "lodash";
import { updateBidDetailsValidation } from "./bidDetailsSlice";
import messages from "../helpers/messages";

export const initialState = {
  step: 1,
  unsavedChanges: false,
  validationData: { ...newBidValidationDefaults }
};

const newBidSlice = createSlice({
  name: "newBid",
  initialState,
  reducers: {
    updateStep: (state, { payload }) => {
      state.step = payload;
    },
    updateValidation: (state, { payload }) => {
      state.validationData = payload;
    },
    updateUnsavedChanges: (state, { payload }) => {
      state.unsavedChanges = payload;
    },
    resetState: state => initialState
  }
});

export const {
  updateStep,
  updateValidation,
  updateUnsavedChanges,
  resetState
} = newBidSlice.actions;

export const newBidReducer = newBidSlice.reducer;

export const fetchBidNameExists =
  (name, shipperId, isBidView = false) =>
  async (dispatch, getState) => {
    let bidNameExists;
    let { validationData } = isBidView
      ? cloneDeep(getState().bidDetails)
      : cloneDeep(getState().newBid);

    try {
      if (shipperId) {
        bidNameExists = (await getBidNameExistsForShipper(name, shipperId))
          .data;
      } else {
        bidNameExists = (await getBidNameExists(name)).data;
      }

      if (bidNameExists) {
        validationData.bidInformation.rfqName = {
          isValid: false,
          validationMessage: messages.uniqueBidNameIsAlreadyInUse.defaultMessage
        };
      } else {
        validationData.bidInformation.rfqName = {
          isValid: true,
          validationMessage: ""
        };
      }
    } catch {
      validationData.bidInformation.rfqName = {
        isValid: false,
        validationMessage: messages.uniqueBidNameIsAlreadyInUse.defaultMessage
      };
    }
    isBidView
      ? dispatch(updateBidDetailsValidation(validationData))
      : dispatch(updateValidation(validationData));
  };
